import { render, staticRenderFns } from "./modalOnboardingHome.vue?vue&type=template&id=0c55eb2a&"
import script from "./modalOnboardingHome.vue?vue&type=script&lang=js&"
export * from "./modalOnboardingHome.vue?vue&type=script&lang=js&"
import style0 from "./modalOnboardingHome.vue?vue&type=style&index=0&id=0c55eb2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports